import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Grid, InputAdornment, TextField, Button } from '@material-ui/core';

// UTILITY
import { customAnalyticsEvent } from '@/utility/analytics';

// COMPONENTS
import RadioCard from '@/components/Form/RadioCard';

// STYLES
import { Title } from '../styles';

const ZipCode = props => {
  const {
    values,
    handleBlur,
    touched,
    errors,
    counties,
    onSubmitPress,
    showCountyStep,
    onChangeZipCode,
    onChangeCounty,
  } = props;
  const [t] = useTranslation();

  useEffect(() => {
    customAnalyticsEvent('Zip Code Form Shown', {});
  }, []);

  return (
    <>
      {!showCountyStep ? (
        <Title className="m-b-30" variant="h5" align="center" component="h2">
          {t('channels.channels.title2')}
        </Title>
      ) : (
        <Title className="m-b-30" variant="h5" align="center" component="h2">
          {t('start.counties.title')}
        </Title>
      )}
      {!showCountyStep ? (
        <Grid className="m-b-30" container spacing={4}>
          <Grid item xs={7} md={8} lg={9}>
            <TextField
              label={t('inputs.zipcode')}
              InputProps={{
                endAdornment: (
                  <InputAdornment
                    className={!errors.zipcode && values.zipcode ? 'success' : ''}
                    position="start"
                  >
                    <i className="icon-check" />
                  </InputAdornment>
                ),
              }}
              type="tel"
              name="zipcode"
              value={values.zipcode}
              onChange={onChangeZipCode}
              onBlur={handleBlur}
              error={touched.zipcode && !!errors.zipcode}
              helperText={touched.zipcode && errors.zipcode}
              className="zipcodeinput"
            />
          </Grid>
          <Grid item xs={5} md={4} lg={3}>
            <Button
              color="primary"
              fullWidth
              onClick={onSubmitPress}
              disabled={!values.zipcode.length || !!errors.zipcode}
              style={{ marginTop: '5px' }}
              className="channels-zipcode__submit"
            >
              {t('buttons.submit')}
            </Button>
          </Grid>
        </Grid>
      ) : (
        <Grid className="m-b-30" container spacing={1} justifyContent="center">
          {counties.map(item => (
            <Grid item xs={6} sm={6} md={3} key={item.county_id}>
              <RadioCard
                name="county_id_fk"
                text={item.county_name}
                handleChange={onChangeCounty}
                handleBlur={handleBlur}
                value={item.county_id.toString()}
                checkedValue={values.county_id_fk}
                dataAttributes={{ 'data-dma_id_fk': item.dma_id_fk.toString() }}
              />
            </Grid>
          ))}
        </Grid>
      )}
    </>
  );
};

ZipCode.propTypes = {
  values: PropTypes.object.isRequired,
  handleBlur: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  touched: PropTypes.object.isRequired,
  counties: PropTypes.oneOfType([PropTypes.array, PropTypes.oneOf([null])]),
  onSubmitPress: PropTypes.func.isRequired,
  showCountyStep: PropTypes.bool.isRequired,
  onChangeZipCode: PropTypes.func.isRequired,
  onChangeCounty: PropTypes.func.isRequired,
};

export default React.memo(ZipCode);
